import {Breadcrumbs, Grid, Typography} from "@mui/material";
import LinkNavegacao from "../../../common/Link";
import HomeIcon from "@mui/icons-material/Home";
import PageTitle from "../../../common/PageTitle";
import {CloudRefreshIcon} from "../../../common/Icons";
import CardOption from "../../../common/CardOption";

export function DataManagement() {
    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="stretch"
            spacing={2}
        >
            <Grid item xs={12}>
                <Breadcrumbs>
                    <LinkNavegacao to='/'><HomeIcon fontSize='small'/></LinkNavegacao>
                    <Typography variant='span'>Gerenciamento admin</Typography>
                    <Typography variant='span'>Gerenciamento de dados</Typography>
                </Breadcrumbs>

                <PageTitle icon={<CloudRefreshIcon fontSize='large'/>} title='Gerenciamento de dados' />
                <Typography mt={2}>Gerencie os dados do sistema</Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4} xl={3} mt={4}>
                <CardOption
                    title="Importação de planilhas"
                    description="Realize a importação de dados de novas empresas."
                    url='importacao'
                />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4} xl={3} mt={4}>
                <CardOption
                    title="Registro de logs"
                    description="Acompanhe as ações que estão sendo realizadas no sistema."
                    url='logs'
                />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4} xl={3} mt={4}>
                <CardOption
                    title="Erros de request"
                    description="Acompanhe os erros de requisição."
                    url='erros'
                />
            </Grid>
        </Grid>
    )
}